import { bl_del_job_dochdr_link_RowClass, bl_del_job_dochdr_link_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobDocHeaderLinkContainerModel extends BaseContainerModel {
  bl_del_job_dochdr_link: bl_del_job_dochdr_link_RowInterface = new bl_del_job_dochdr_link_RowClass();
}